module.exports = __webpack_public_path__ + "img/B2B.7354973c.jpg";